import {
  oliveAvatarTokens,
  oliveBackgroundTokens,
  oliveBadgeTokens,
  oliveBarTokens,
  oliveBorderTokens,
  oliveBreakpointTokens,
  oliveCTATokens,
  oliveElevationTokens,
  oliveFocusTokens,
  oliveFontTokens,
  oliveFormTokens,
  oliveIconTokens,
  oliveItemTokens,
  oliveMessageTokens,
  oliveOpacityTokens,
  oliveSpacingTokens,
  oliveStatusTokens,
  oliveTagTokens,
} from '@ds/tokens'

export default {
  barFillColorAccentEmphasis: '#37039e',
  barFillColorEmphasis: '#1e181e',
  barStopIndicatorColor: 'rgba(30, 24, 30, 0.5)',
  barTrackColorVisited: '#260559',
  bgColorAccent: '#260559',
  bgColorAccentSubtle: '#ff5c33',
  bgColorBrand: '#4c00fb',
  bgColorGlassFrost: 'rgba(255, 255, 255, 0.9)',
  bgColorGlassTint: 'rgba(30, 24, 30, 0.8)',
  bgColorPopoverClose: 'rgba(255, 255, 255, 0.8)',
  bgColorPopoverCloseInverse: 'rgba(30, 24, 30, 0.8)',
  bgColorWarning: '#fce1c2',
  borderColorAccent: '#37039e',
  borderColorError: '#ec004c',
  borderColorSuccess: '#00875c',
  borderColorWarning: '#dc4e00',
  ctaBgColorBrandActive: '#4200ca',
  ctaBgColorBrandDefault: '#4c00fb',
  ctaBgColorBrandHover: '#5f32ff',
  ctaComboBorderColorBrandDefault: '#ffffff',
  ctaFabBgColorMainActive: '#4200ca',
  ctaFabBgColorMainDefault: '#4c00fb',
  ctaFabBgColorMainHover: '#5f32ff',
  ctaIconBgColorTertiaryDefault: 'transparent',
  ctaToggleBgColorSelectedSubtle: 'rgba(30, 24, 30, 0.1)',
  ctaToggleBgColorSelectedSubtleActive: 'rgba(30, 24, 30, 0.2)',
  ctaToggleBgColorSelectedSubtleHover: 'rgba(30, 24, 30, 0.15)',
  deviceBreakpointXXL: '1920px',
  elevationGlass: '16px',
  fontBodyS: {
    fontFamily: '"DS Indigo",DSIndigo,Helvetica,Arial,sans-serif',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '1.4',
  },
  fontButtonS: oliveFontTokens.fontButton,
  fontLabel: {
    fontFamily: '"DS Indigo",DSIndigo,Helvetica,Arial,sans-serif',
    fontSize: '13px',
    fontWeight: 600,
    lineHeight: '18px',
  },
  fontLabelEmphasis: {
    fontFamily: '"Maven Pro",Helvetica,Arial,sans-serif',
    fontSize: '35px',
    fontWeight: 700,
    lineHeight: '1.5',
  },
  fontLinkS: {
    fontFamily: '"DS Indigo",DSIndigo,Helvetica,Arial,sans-serif',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '1.4',
    textDecoration: 'underline',
  },
  fontColorAccent: '#4c00fb',
  fontColorAccentEmphasis: '#4200ca',
  fontColorAccentSubtle: '#dbd6fe',
  fontColorErrorEmphasis: '#a6003f',
  fontColorErrorSubtle: '#fed6d8',
  fontColorLinkSubtleActive: '#1e181e',
  fontColorLinkSubtleHover: 'rgba(30, 24, 30, 0.8)',
  fontColorLinkSubtleVisited: 'rgba(30, 24, 30, 0.7)',
  fontColorSuccessEmphasis: '#005f43',
  fontColorSuccessSubtle: '#84efc3',
  fontColorWarning: '#bf3e07',
  fontColorWarningEmphasis: '#a52608',
  fontColorWarningSubtle: '#fdcc9a',
  formBorderColorError: '#d13239',
  formBgColorSelectedActive: '#164295',
  formBgColorDefault: '#ffffff',
  formBgColorError: '#d13239',
  formBgColorSelectedHover: '#164295',
  formBgColorSelected: '#2463d1',
  formBorderColorActive: '#1e1e1e',
  formBorderColorSelected: '#2463d1',
  formBorderColorSelectedActive: '#005cb9',
  formBorderColorSelectedHover: '#1951b8',
  formHighlightBgColorDefault: '#e9e9e9',
  formThumbBgColorDefault: '#1e1e1e',
  formBgColorDisabled: '#f4f4f4',
  formBgColorRead: '#f9f9f9',
  formBorderColorDefault: '#868686',
  formBorderColorHover: '#868686',
  formBorderWidth: '1px',
  formBorderWidthActive: '2px',
  formTextColorRequired: '#d13239',
  formTextColorDisabled: '#999999',
  iconColorAccent: '#4c00fb',
  iconColorAccentEmphasis: '#868686',
  iconColorInverseSubtle: 'rgba(255, 255, 255, 0.7)',
  iconColorPromo: '#37039e',
  iconColorSubtle: 'rgba(30, 24, 30, 0.7)',
  radiusSizeFull: '9999px',
  radiusSizeL: '12px',
  radiusSizeM: '8px',
  radiusSizeS: '4px',
  radiusSizeXS: '2px',
  spacingGap100: '8px',
  spacingGap150: '12px',
  spacingGap200: '16px',
  spacingGap250: '20px',
  spacingGap300: '24px',
  spacingGap400: '32px',
  spacingGap50: '4px',
  spacingGap500: '40px',
  spacingGap600: '48px',
  spacingGap700: '64px',
  statusBgColorAccent: '#37039e',
  statusBgColorNeutral: 'rgba(30, 24, 30, 0.7)',
  ...oliveAvatarTokens,
  avatarBgColorSign: '#b8bfcc' as const,
  ...oliveBackgroundTokens,
  ...oliveBadgeTokens,
  ...oliveBarTokens,
  ...oliveBorderTokens,
  ...oliveBreakpointTokens,
  ...oliveCTATokens,
  ...oliveElevationTokens,
  ...oliveFocusTokens,
  ...oliveFontTokens,
  ...oliveFormTokens,
  ...oliveIconTokens,
  ...oliveItemTokens,
  ...oliveMessageTokens,
  ...oliveOpacityTokens,
  ...oliveSpacingTokens,
  ...oliveStatusTokens,
  ...oliveTagTokens,
  recipientBgColor100: '#e8edf7',
  dark: {} as Record<string, never>,
} as const
